var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_798_11198)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.74603V18.254C5 19.2183 5.76951 20 6.71875 20H18.2812C19.2305 20 20 19.2183 20 18.254V4.59454C20 4.12814 19.8163 3.68112 19.4899 3.35314L16.6549 0.504633C16.3331 0.181331 15.8988 0 15.4463 0H6.71875C5.76951 0 5 0.781725 5 1.74603ZM6.09375 18.254V1.74603C6.09375 1.39537 6.37357 1.11111 6.71875 1.11111H15.2344V4.92064C15.2344 5.57812 15.759 6.11111 16.4062 6.11111H18.9062V18.254C18.9062 18.6046 18.6264 18.8889 18.2812 18.8889H6.71875C6.37357 18.8889 6.09375 18.6046 6.09375 18.254ZM18.9062 5V4.59454C18.9062 4.42494 18.8395 4.26239 18.7208 4.14312L16.3281 1.73909V4.92064C16.3281 4.96447 16.3631 5 16.4062 5H18.9062Z",
    fill: "#414B56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8125 8.20312C12.8125 7.90109 13.0573 7.65625 13.3594 7.65625H16.9531C17.2552 7.65625 17.5 7.90109 17.5 8.20312C17.5 8.50516 17.2552 8.75 16.9531 8.75H13.3594C13.0573 8.75 12.8125 8.50516 12.8125 8.20312Z",
    fill: "#414B56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8125 10.7031C12.8125 10.4011 13.0573 10.1562 13.3594 10.1562H16.9531C17.2552 10.1562 17.5 10.4011 17.5 10.7031C17.5 11.0052 17.2552 11.25 16.9531 11.25H13.3594C13.0573 11.25 12.8125 11.0052 12.8125 10.7031Z",
    fill: "#414B56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8125 13.2031C12.8125 12.9011 13.0573 12.6562 13.3594 12.6562H16.9531C17.2552 12.6562 17.5 12.9011 17.5 13.2031C17.5 13.5052 17.2552 13.75 16.9531 13.75H13.3594C13.0573 13.75 12.8125 13.5052 12.8125 13.2031Z",
    fill: "#414B56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.78125C0 5.26348 0.419733 4.84375 0.9375 4.84375H10.3125C10.8303 4.84375 11.25 5.26348 11.25 5.78125V15.1562C11.25 15.674 10.8303 16.0938 10.3125 16.0938H0.9375C0.419733 16.0938 0 15.674 0 15.1562V5.78125Z",
    fill: "#3D8A58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 13.6072L4.88098 10.3387L3.28735 7.34375H4.50073L5.5304 9.35608L6.5387 7.34375H7.73926L6.14563 10.3857L7.90161 13.6072H6.64978L5.50903 11.441L4.36829 13.6072H3.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_798_11198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementExcel);
export default __webpack_public_path__ + "static/media/icon_settlement_excel.45f49b8cb7d813765630bdaad3f22f85.svg";
export { ForwardRef as ReactComponent };